(() => {
  function init() {
    document.querySelectorAll('[data-soma-cupping],[data-soma-pads]').forEach(root => {
      const cupping = root.hasAttribute('data-soma-cupping');
      const stage = root.querySelector(cupping ? '.sv-stage' : '.sr-main-image');
      const rail = root.querySelector(cupping ? '.sc-thumbs' : '.sr-thumbnails');
      const proxy = stage?.querySelector(cupping ? '[data-main]' : '[data-sr-main]');
      const thumbs = [...(rail?.querySelectorAll('button[data-image]') || [])];
      if (!stage || !proxy || thumbs.length < 2 || stage.dataset.nativeGalleryReady) return;
      stage.dataset.nativeGalleryReady = 'true';
      stage.classList.add('soma-native-stage');
      // Existing product scripts keep this image reference for variant/thumbnail state.
      // Its original dimensions also preserve the approved gallery aspect ratio.
      proxy.classList.add('soma-gallery-proxy');
      proxy.setAttribute('aria-hidden', 'true');
      const fr = document.documentElement.lang.startsWith('fr');
      const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
      const active = () => Math.max(0, thumbs.findIndex(t => t.getAttribute('aria-pressed') === 'true'));
      const track = document.createElement('div');
      track.className = 'soma-native-track';
      track.tabIndex = 0;
      track.setAttribute('role', 'region');
      track.setAttribute('aria-roledescription', 'carousel');
      track.setAttribute('aria-label', fr ? 'Photos du produit' : 'Product photos');
      thumbs.forEach((thumb, i) => {
        const slide = document.createElement('div');
        slide.className = 'soma-native-slide';
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        slide.setAttribute('aria-label', `${i + 1} / ${thumbs.length}`);
        const img = document.createElement('img');
        img.src = thumb.dataset.image;
        img.alt = thumb.querySelector('img')?.alt || thumb.getAttribute('aria-label') || '';
        img.draggable = false;
        img.loading = i === active() ? 'eager' : 'lazy';
        img.decoding = 'async';
        if (thumb.dataset.selectColor || !cupping) slide.classList.add('is-contained');
        slide.append(img);
        track.append(slide);
      });
      stage.append(track);
      const nav = document.createElement('div');
      nav.className = 'soma-gallery-nav';
      const arrow = '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14m-6-6 6 6-6 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      nav.innerHTML = `<button type="button" data-gallery-prev aria-label="${fr ? 'Photo précédente' : 'Previous photo'}">${arrow}</button><span aria-live="polite" aria-atomic="true"></span><button type="button" data-gallery-next aria-label="${fr ? 'Photo suivante' : 'Next photo'}">${arrow}</button>`;
      stage.insertAdjacentElement('afterend', nav);
      const counter = nav.querySelector('span');
      let selected = active(), fromScroll = false, timer, mouse = null;
      function display() {
        counter.textContent = `${selected + 1} / ${thumbs.length}`;
        [...track.children].forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== selected)));
      }
      function scrollToSelected(animate = true) {
        track.scrollTo({left: selected * track.clientWidth, behavior: animate && !reduced() ? 'smooth' : 'instant'});
      }
      function sync() {
        const next = active();
        const changed = next !== selected;
        selected = next;
        display();
        if (changed && !fromScroll) scrollToSelected();
      }
      function settle() {
        if (mouse || !track.clientWidth) return;
        const index = Math.max(0, Math.min(thumbs.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        // Only commit a snapped slide, never an intermediate frame of a smooth scroll.
        if (Math.abs(track.scrollLeft - index * track.clientWidth) > 2) return;
        if (index !== active()) {
          fromScroll = true;
          selected = index;
          thumbs[index].click();
          display();
          fromScroll = false;
        }
      }
      track.addEventListener('scroll', () => { clearTimeout(timer); timer = setTimeout(settle, 180); }, {passive: true});
      track.addEventListener('scrollend', settle);
      function step(delta) {
        selected = (active() + delta + thumbs.length) % thumbs.length;
        thumbs[selected].click();
        display();
        scrollToSelected();
      }
      nav.querySelector('[data-gallery-prev]').addEventListener('click', () => step(-1));
      nav.querySelector('[data-gallery-next]').addEventListener('click', () => step(1));
      track.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); step(e.key === 'ArrowLeft' ? -1 : 1); }
      });
      // Touch uses the browser's native scrolling. Mouse drag also works in mobile previews.
      track.addEventListener('pointerdown', e => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        mouse = {id: e.pointerId, x: e.clientX, left: track.scrollLeft};
        track.classList.add('is-dragging');
        track.setPointerCapture(e.pointerId);
        e.preventDefault();
      });
      track.addEventListener('pointermove', e => {
        if (mouse?.id === e.pointerId) track.scrollLeft = mouse.left + mouse.x - e.clientX;
      });
      function endDrag(e) {
        if (mouse?.id !== e.pointerId) return;
        const index = Math.max(0, Math.min(thumbs.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        mouse = null;
        track.classList.remove('is-dragging');
        selected = index;
        thumbs[index].click();
        display();
        scrollToSelected();
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      new MutationObserver(sync).observe(rail, {subtree: true, attributes: true, attributeFilter: ['aria-pressed']});
      new ResizeObserver(() => scrollToSelected(false)).observe(stage);
      display();
      scrollToSelected(false);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
